function generateTOC() {
  const $content = $('.article-main-content');
  const $tocList = $('#toc .toc-list');
  const $tocTitle = $('#toc .toc-title');
  if (!$content.length || !$tocList.length) return;

  // Get all heading tags (h1-h6)
  const $headings = $content.find('h2, h3');
  let tocHTML = '';
  let sectionIndex = 0;
  let isAnimating = false;

  $headings.each(function () {
    const $el = $(this);
    sectionIndex++;
    const id = `section-${sectionIndex}`;
    $el.attr('id', id);

    // Add indentation based on heading level
    const level = parseInt($el.prop('tagName').substring(1));
    // Set h1 and h2 as level 1
    const adjustedLevel = level <= 2 ? 1 : level - 1;
    const padding = (adjustedLevel - 1) * 20; // 20px indentation per level

    tocHTML += `<li data-level="${adjustedLevel}" style="padding-left: ${padding}px"><a href="#${id}">${$el.text()}</a></li>`;
  });

  $tocList.html(tocHTML);

  // Toggle TOC list
  $tocTitle.on('click', function() {
    if (isAnimating) return;

    isAnimating = true;
    $tocTitle.toggleClass('collapsed');

    $tocList.slideToggle(100, function() {
      isAnimating = false;
    });
  });

  // Scroll mượt khi click
  $tocList.find('a').on('click', function (e) {
    e.preventDefault();
    const targetId = $(this).attr('href');
    const $target = $(targetId);
    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - 60
      }, 500);
    }
  });

  // Add Intersection Observer for active state
  const observerOptions = {
    root: null,
    rootMargin: '-60px 0px -50% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const id = entry.target.getAttribute('id');
      const $tocLink = $tocList.find(`a[href="#${id}"]`);

      if (entry.isIntersecting) {
        $tocList.find('a').removeClass('active');
        $tocLink.addClass('active');
      }
    });
  }, observerOptions);

  // Observe all headings
  $headings.each(function() {
    observer.observe(this);
  });
}

// Gọi hàm
generateTOC();
